import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppLoadService {
  private isFirstLoad = true;

  constructor() {}

  public getIsFirstLoad(): boolean {
    const isFirstLoad = this.isFirstLoad;
    this.isFirstLoad = false;
    return isFirstLoad;
  }

  public setIsFirstLoad() {
    this.isFirstLoad = true;
  }
}
